(function () {
  'use strict';

  // Satrah Cart JS
  // Loaded once from layout/theme.liquid via asset_url.
  // Responsibilities:
  // 1. Zorble bundle removal logic
  // 2. Block product page links inside addon panels
  // 3. Colour orb cleanup

  function satrahFetchWithTimeout(url, options, ms) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, ms || 7000);
    var opts = Object.assign({}, options || {}, { signal: controller.signal });

    return fetch(url, opts).finally(function () {
      clearTimeout(timer);
    });
  }

  function satrahFormatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : undefined);
    }

    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function satrahUpdateCartCount(cart) {
    if (!cart) return;

    document.querySelectorAll('.sf-cart-count, [data-cart-count], .cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  function satrahUpdateSubtotal(cart) {
    if (!cart) return;

    document.querySelectorAll('[data-cart-subtotal-price]').forEach(function (el) {
      el.innerHTML = satrahFormatMoney(cart.total_price);
    });
  }

  var satrahWritingBar = false;

  // Drive Foxkit's own .f-cartgoal element (already styled by Foxkit's global
  // stylesheet). We populate the exact elements Foxkit's own script targets:
  //   - data-goal  : threshold in cents (read, not written) — set in the
  //                  Foxkit app, so the free-shipping amount lives there.
  //   - --progress : CSS var that fills the bar.
  //   - [data-progress] : numeric progress mirror.
  //   - [data-goal-left]: remaining-amount text inside the merchant message.
  //   - .hidden    : removed once populated so the bar appears.
  function satrahUpdateFreeShipping(cart) {
    if (!cart) return;
    if (typeof cart.total_price === 'number') {
      satrahLastKnownTotal = cart.total_price;
    }

    satrahWritingBar = true;

    document.querySelectorAll('.f-cartgoal').forEach(function (goal) {
      // Free-shipping threshold in CENTS. Hardcoded so the bar no longer
      // depends on Foxkit's data-goal attribute (which disappears/goes stale
      // when Foxkit's own script errors out). $60 AUD = 6000 cents.
      var SATRAH_FREE_SHIP_THRESHOLD = 6000;

      // Prefer the hardcoded value; only fall back to Foxkit's data-goal if
      // the constant were ever unset. This guarantees a correct threshold
      // even when Foxkit fails to load.
      var threshold = SATRAH_FREE_SHIP_THRESHOLD;
      if (!threshold || threshold < 1) {
        threshold = parseInt(goal.getAttribute('data-goal'), 10);
      }
      if (!threshold || threshold < 1) return;

      var total = cart.total_price;
      var remaining = threshold - total;
      var progress = Math.min(100, Math.max(0, Math.round((total / threshold) * 100)));

      // Foxkit fills the bar and positions the star from the --progress CSS
      // var on .f-cartgoal. Drive ONLY that (matching the /cart behaviour);
      // do not set an inline width on the span, which double-drives the fill
      // and paints the whole track.
      goal.style.setProperty('--progress', progress + '%');
      goal.querySelectorAll('[data-progress]').forEach(function (el) {
        el.setAttribute('data-progress', progress);
        el.style.removeProperty('width');
      });

      // Remaining-amount text. Foxkit injects <span data-goal-left> into the
      // merchant message where {{variable}} was. When the goal is met,
      // remaining is 0 and the span simply shows the formatted $0 / nothing.
      var leftEls = goal.querySelectorAll('[data-goal-left]');
      var remainingText = satrahFormatMoney(remaining > 0 ? remaining : 0);
      leftEls.forEach(function (el) {
        if (el.textContent !== remainingText) {
          el.textContent = remainingText;
        }
      });

      // Mark met state (Foxkit adds this class on its own builds; harmless if
      // unstyled).
      if (remaining <= 0) {
        goal.classList.add('f-cartgoal--reached');
      } else {
        goal.classList.remove('f-cartgoal--reached');
      }

      // Reveal once populated.
      goal.classList.remove('hidden');
    });

    setTimeout(function () { satrahWritingBar = false; }, 0);
  }

  // Self-sufficient refresh: fetch the live cart and update the goal bar.
  var satrahShippingDebounceTimer = null;
  var satrahLatestRequestId = 0;
  var satrahLastKnownTotal = null;

  // Apply a known total to the bar synchronously (no network). Used the instant
  // the drawer re-renders so the server-rendered (stale) --progress is
  // overwritten before the browser paints it, killing the slide-to-end flash.
  function satrahApplyTotalToBar(total) {
    if (typeof total !== 'number') return;
    satrahUpdateFreeShipping({ total_price: total });
  }

  function satrahScheduleShippingRefresh() {
    if (satrahShippingDebounceTimer) {
      clearTimeout(satrahShippingDebounceTimer);
    }
    satrahShippingDebounceTimer = setTimeout(function () {
      satrahShippingDebounceTimer = null;
      satrahRefreshFreeShipping();
    }, 350);
  }

  function satrahRefreshFreeShipping() {
    if (!document.querySelector('.f-cartgoal')) return;

    // Always issue a fresh request and apply only the latest response, so a
    // late-landing section-render or a stale in-flight fetch can't overwrite
    // the correct value. (The newest read wins.)
    var requestId = ++satrahLatestRequestId;

    satrahFetchWithTimeout(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    }, 7000)
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (requestId !== satrahLatestRequestId) return;
        satrahUpdateFreeShipping(cart);
      })
      .catch(function () { /* leave existing markup in place */ });
  }

  function satrahRenderEmptyCartIfNeeded(cart) {
    if (!cart || cart.item_count > 0) return;

    var form = document.querySelector('#cart-drawer-form');
    if (!form) return;

    form.innerHTML = '' +
      '<div class="scd-empty-msg">' +
        '<p class="scd-empty-msg__title">Bit empty in here.</p>' +
        '<p class="scd-empty-msg__text">Grab a dragon, a fidget or a cookie cutter and let\'s get this cart moving.</p>' +
        '<div class="scd-empty-msg__links">' +
          '<a href="/collections/dragons" class="scd-empty-msg__link">Dragons</a>' +
          '<a href="/collections/articulated" class="scd-empty-msg__link">Fidgets</a>' +
          '<a href="/collections/cookie-cutters" class="scd-empty-msg__link">Cookie Cutters</a>' +
          '<a href="/collections/mystery-boxes" class="scd-empty-msg__link">Mystery Boxes</a>' +
        '</div>' +
        '<a href="/collections/all" class="scd-empty-msg__all">Browse everything</a>' +
      '</div>';
  }

  function satrahApplyCartState(cart) {
    satrahUpdateCartCount(cart);
    satrahUpdateSubtotal(cart);
    satrahUpdateFreeShipping(cart);
    satrahRenderEmptyCartIfNeeded(cart);

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
  }

  function satrahRemoveVisibleNodes(clickedInsideAddon, addonBlock, lineGroup, cart) {
    if (clickedInsideAddon && addonBlock) {
      addonBlock.remove();
    } else if (lineGroup) {
      lineGroup.remove();
    }

    satrahRenderEmptyCartIfNeeded(cart);
  }

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('.scd-item__remove');
    if (!removeBtn) return;

    var itemKey = removeBtn.getAttribute('data-id');
    if (!itemKey) return;

    var lineGroup = removeBtn.closest('[data-cart-line-group]');
    if (!lineGroup) return;

    var addonBlock = removeBtn.closest('[data-cart-addon]');
    var clickedInsideAddon = !!addonBlock;

    var keysToRemove = [];

    if (clickedInsideAddon) {
      keysToRemove = [itemKey];
    } else {
      keysToRemove = [itemKey];

      lineGroup.querySelectorAll('[data-cart-addon] .scd-item__remove, [data-cart-addon] button[data-id]').forEach(function (btn) {
        var key = btn.getAttribute('data-id');
        if (key && keysToRemove.indexOf(key) === -1) {
          keysToRemove.push(key);
        }
      });

      if (keysToRemove.length <= 1) {
        return;
      }
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    var busyEl = clickedInsideAddon && addonBlock ? addonBlock : lineGroup;
    busyEl.style.opacity = '0.4';
    busyEl.style.pointerEvents = 'none';

    var request;

    if (clickedInsideAddon) {
      request = satrahFetchWithTimeout(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0
        })
      }, 7000);
    } else {
      var updates = {};
      keysToRemove.forEach(function (key) {
        updates[key] = 0;
      });

      request = satrahFetchWithTimeout(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates: updates })
      }, 7000);
    }

    request
      .then(function (r) {
        if (!r.ok) throw new Error('Cart remove request failed with status ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        satrahRemoveVisibleNodes(clickedInsideAddon, addonBlock, lineGroup, cart);
        satrahApplyCartState(cart);
      })
      .catch(function (err) {
        console.error('[Satrah cart] Bundle remove error:', err);
        window.location.reload();
      })
      .finally(function () {
        if (busyEl && busyEl.style) {
          busyEl.style.opacity = '';
          busyEl.style.pointerEvents = '';
        }

        var itemsEl = document.querySelector('.scd__items');
        if (itemsEl) {
          itemsEl.style.opacity = '';
          itemsEl.style.pointerEvents = '';
        }
      });
  }, true);

  // Block product links inside addon panels.
  document.addEventListener('click', function (e) {
    var link = e.target.closest(
      '.satrah-cart-addon a[href*="/products/"], ' +
      '.satrah-cart-line-group[data-bundle-role="addon"] a[href*="/products/"], ' +
      '.satrah-cart-line-group[data-bundle-role="clicker_extra_keys"] a[href*="/products/"]'
    );

    if (!link) return;

    e.preventDefault();
    e.stopPropagation();
  });

  // Colour orb cleanup.
  function satrahRunCartFixes() {
    document.querySelectorAll('[data-satrah-colour-orb]').forEach(function (orb) {
      orb.remove();
    });
  }

  // Quantity changes on an existing line don't add/remove DOM nodes, so the
  // childList observer may not fire. Catch qty +/- clicks and typed input
  // anywhere in the drawer and schedule a debounced live refresh.
  function satrahIsInsideCart(node) {
    if (!node || !node.closest) return false;
    return !!node.closest('.scd__wrapper, [data-cart-wrapper]');
  }

  document.addEventListener('click', function (e) {
    if (satrahIsInsideCart(e.target)) {
      satrahScheduleShippingRefresh();
    }
  });

  document.addEventListener('change', function (e) {
    if (satrahIsInsideCart(e.target)) {
      satrahScheduleShippingRefresh();
    }
  });

  var satrahOrbObserver = null;
  var satrahOrbObserverTimer = null;

  function satrahScheduleOrbCleanup() {
    if (satrahWritingBar) return;
    if (satrahOrbObserverTimer) return;

    satrahOrbObserverTimer = setTimeout(function () {
      satrahOrbObserverTimer = null;
      satrahRunCartFixes();
      satrahRefreshFreeShipping();
    }, 50);
  }

  function satrahAttachOrbObserver() {
    var target =
      document.querySelector('.scd__items') ||
      document.querySelector('.scd__wrapper') ||
      document.querySelector('[data-cart-wrapper]');

    if (!target) return;

    if (satrahOrbObserver) {
      satrahOrbObserver.disconnect();
    }

    satrahOrbObserver = new MutationObserver(satrahScheduleOrbCleanup);
    satrahOrbObserver.observe(target, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['value', 'data-quantity', 'data-cart-quantity', 'aria-valuenow']
    });
  }

  // The theme re-renders the whole drawer via the Section Rendering API,
  // which detaches the observed node above. This permanent body-level
  // observer can never be detached, so it's the reliable failsafe: any time
  // the drawer subtree changes, refresh the bar from the live cart.
  var satrahBodyObserver = null;
  var satrahBodyObserverTimer = null;

  function satrahAttachBodyObserver() {
    if (satrahBodyObserver || !document.body) return;

    satrahBodyObserver = new MutationObserver(function (mutations) {
      if (satrahWritingBar) return;

      var touchedDrawer = false;

      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        var node = m.target;
        if (node && node.closest && node.closest('.scd__wrapper, [data-cart-wrapper]')) {
          touchedDrawer = true;
          break;
        }
      }

      if (!touchedDrawer) return;

      // Synchronously overwrite the just-swapped-in (stale) server value with
      // the last total we actually know, before the browser paints it. This
      // kills the slide-to-end-then-back flash. The confirming fetch below
      // then verifies against the live cart.
      if (satrahLastKnownTotal !== null) {
        satrahApplyTotalToBar(satrahLastKnownTotal);
      }

      if (satrahBodyObserverTimer) return;

      satrahBodyObserverTimer = setTimeout(function () {
        satrahBodyObserverTimer = null;
        satrahAttachOrbObserver();
        satrahRefreshFreeShipping();
      }, 6000);
    });

    satrahBodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  // Most reliable trigger: intercept Shopify cart-mutation requests and
  // update the bar from the actual response. This can't lose a race against
  // the theme's own qty/add/remove AJAX, and it doesn't depend on the theme
  // dispatching any event or mutating DOM in a way we can observe.
  (function satrahPatchFetch() {
    if (!window.fetch || window.fetch.__satrahPatched) return;

    var nativeFetch = window.fetch;

    var cartMutationRe = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;
    var sectionRenderRe = /[?&]section_id=cart-drawer/i;

    window.fetch = function () {
      var args = arguments;
      var url = '';

      try {
        url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      } catch (e) {
        url = '';
      }

      var isCartMutation = cartMutationRe.test(url);
      var isSectionRender = sectionRenderRe.test(url);

      var result = nativeFetch.apply(this, args);

      if (!isCartMutation && !isSectionRender) return result;

      return result.then(function (response) {
        // A section render returns HTML that replaces the drawer with
        // SERVER-rendered Liquid — and that Liquid often reflects the cart
        // total from BEFORE this change (one step stale). The theme inserts
        // that HTML a moment after this response resolves. So we re-read the
        // live cart and rewrite the bar at several points after the swap;
        // the requestId guard ensures only the newest read sticks, so we
        // always end on the correct value regardless of swap timing.
        if (isSectionRender) {
          [80, 250, 600].forEach(function (delay) {
            setTimeout(function () {
              satrahAttachOrbObserver();
              satrahRefreshFreeShipping();
            }, delay);
          });
          return response;
        }

        // Cart mutation: update from the response if it's the full cart,
        // otherwise refetch.
        try {
          var clone = response.clone();
          clone.json().then(function (data) {
            if (data && typeof data.total_price === 'number' && typeof data.item_count === 'number') {
              satrahUpdateFreeShipping(data);
              // The theme may still re-render the drawer afterwards, so also
              // schedule a post-render refresh as a safety net.
              satrahScheduleShippingRefresh();
            } else {
              satrahScheduleShippingRefresh();
            }
          }).catch(function () {
            satrahScheduleShippingRefresh();
          });
        } catch (e) {
          satrahScheduleShippingRefresh();
        }

        return response;
      });
    };

    window.fetch.__satrahPatched = true;
  }());

  document.addEventListener('DOMContentLoaded', function () {
    satrahRunCartFixes();
    satrahAttachOrbObserver();
    satrahAttachBodyObserver();
    satrahRefreshFreeShipping();
  });

  document.addEventListener('cart:open', function () {
    satrahRunCartFixes();
    satrahAttachOrbObserver();
    satrahRefreshFreeShipping();
  });

  document.addEventListener('cart:updated', function () {
    satrahRunCartFixes();
    satrahAttachOrbObserver();
    satrahRefreshFreeShipping();
  });

  document.addEventListener('cart:refresh', function () {
    satrahRunCartFixes();
    satrahAttachOrbObserver();
    satrahRefreshFreeShipping();
  });

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    satrahRunCartFixes();
    satrahAttachOrbObserver();
    satrahAttachBodyObserver();
  }
}());